/**
 * Display formatting utilities
 * Simplified: loading/toast/confirm are now components
 */

export function formatCurrency(amount) {
  if (!amount || amount === '') return '$0.00';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(num);
}

export function formatCookTime(minutes) {
  if (!minutes) return '';
  const num = typeof minutes === 'string' ? parseInt(minutes) : minutes;
  if (num < 60) return `${num} min`;
  const hours = Math.floor(num / 60);
  const mins = num % 60;
  if (mins === 0) return `${hours} hr`;
  return `${hours} hr ${mins} min`;
}

export function debounce(func, wait = 300) {
  let timeout;
  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}
